<template>
  <entity-edit-dialog
      @submit="submit"
      @close="close"
      v-model="visible"
      ref="editDialog"
      :dialog-title="dialogTitle"
      :submitting="submitting">
    <template v-slot:contentCard>
      <v-card-text class="pt-5">
        <entity-dialog-input-row :label="$t('serviceRequest.location')">
          <location-select v-model="serviceRequest.location"
                             style="max-width: 20em"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('device.singular')">
          <device-select-field :show-select-dialog-button="true"
                               v-model="serviceRequest.device"
                               style="max-width: 30em"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('serviceRequest.message')" :required="true">
          <v-textarea
              v-model="serviceRequest.message"
              rows="3"
              outlined
              hide-details="auto"
              :rules="[buildRequiredValidator(), buildMaxLengthValidator(3000)]"/>
        </entity-dialog-input-row>


        <entity-dialog-input-row :label="$t('serviceRequest.availabilityWindow')">
          <div class="date-range-picker d-inline-flex align-baseline">

            <date-picker
                v-model="serviceRequest.serviceWindowStart"
                :max="serviceRequest.serviceWindowStart"
                :clearable="true"
            />
            <span class="pl-2 pr-2 font-weight-bold">-</span>
            <date-picker
                v-model="serviceRequest.serviceWindowEnd"
                :min="serviceRequest.serviceWindowEnd"
                :clearable="true"
            />
          </div>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('serviceRequest.state')">
          <service-request-state-select v-model="serviceRequest.state"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('serviceRequest.inviter')">
          <v-text-field v-model="serviceRequest.inviter"
                        outlined
                        hide-details="auto"
                        style="max-width: 20em"
                        :rules="[buildMaxLengthValidator(255)]"
          />
        </entity-dialog-input-row>

        <entity-dialog-input-row >
          <v-checkbox v-model="serviceRequest.sendEmails"
                        outlined
                        hide-details="auto"
                        :label="$t('serviceRequest.sendEmails')"
          />
        </entity-dialog-input-row>
      </v-card-text>
    </template>
  </entity-edit-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import DeviceSelectField from '@/components/inputs/DeviceSelectField';
import i18n from '@/i18n';
import EntityEditDialog from '@/components/entity-crud/EntityEditDialog';
import { buildRequiredIfValidator, buildRequiredValidator, buildMaxLengthValidator } from '@/utils/ValidatorBuilders';
import ServiceRequestStateSelect from '@/components/inputs/ServiceRequestStateSelect';
import DateUtils from '@/utils/DateUtils';

import ServiceRequestsService from '@/services/ServiceRequestsService';
import DatePicker from '@/components/inputs/DatePicker';
import LocationSelect from '@/components/inputs/LocationSelect';

export default {
  name: 'ServiceRequestDialog',
  components: {
    LocationSelect,
    DatePicker,
    ServiceRequestStateSelect,
    EntityEditDialog,
    DeviceSelectField,
    EntityDialogInputRow,
  },
  data: () => ({
    serviceRequest: null,
    sendMails: false,
    visible: false,
    submitting: false,

  }),
  props: {},
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    dialogTitle() {
      if (this.serviceRequest?.id) {
        return i18n.t('serviceRequest.editDialog.titleEdit');
      } else {
        return i18n.t('serviceRequest.editDialog.titleAdd');
      }
    },
    isSignerRequired() {
      return this.$store.getters['userSessionStateStore/user']?.sharedAccount;
    },
  },
  methods: {
    buildRequiredIfValidator,
    buildRequiredValidator,
    buildMaxLengthValidator,
    close() {
      this.serviceRequest = null;
      this.visible = false;
      this.submitting = false;
    },

    openCreateNewServiceRequest() {
      this.serviceRequest = {
        device: null,
        location: null,
        serviceWindowStart: DateUtils.toLocalISOdate(new Date()),
        serviceWindowEnd: null,
        message: null,
        reportingUser: null,
        state: 'NEW',
        inviter: null,
      };
      this.visible = true;
      this.sendMails = false;
    },

    openEditForServiceRequest(serviceRequestId) {
      ServiceRequestsService.get(serviceRequestId)
          .then(result => {
            this.serviceRequest = result.data;
            this.visible = true;
            this.sendMails = false;
          }).catch(err => {
        console.log(JSON.stringify(err));
      });
    },


    submit() {
      if (this.submitting) {
        return;
      }

      if (!this.$refs.editDialog.$refs.form.validate()) {
        this.$refs.editDialog.showFormHasValidationErrorsMessage(i18n.t('serviceRequest.requiredInformationMissing'));
        return;
      }

      this.submitting = true;
      ServiceRequestsService.save(this.serviceRequest, this.sendMails).then((result) => {
        this.$emit('done', result.data);
        this.close();
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.repeat-weekdays > * {
  margin-right: 1em;
}
</style>
